import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {WindowRefService, SiteInfosService} from '@app/core';

@Component({
    selector: 'app-fineprint',
    templateUrl: './fineprint.component.html',
    styleUrls: ['./fineprint.component.scss']
})
export class FineprintComponent implements OnInit {
    fineprint: any;
    generateStatus: any = {};
    etablissment = {};
    goodtoknow = {};
    checkInCheckOutBare = { 
        startCheckIn : 0, 
        endCheckIn : 0,
        startCheckOut : 0,
        endCheckOut : 0
    };
    proggressBare = {};
    
    constructor(private winRef: WindowRefService, private dialogRef: MatDialogRef<FineprintComponent>, @Inject(MAT_DIALOG_DATA) data, private siteInfosService: SiteInfosService) {
        this.fineprint = data.fineprint.value;
    }

    ngOnInit() {
        // console.log(this.winRef.appConfigSite);
        this.generateStatus = JSON.parse(this.siteInfosService.getEtabData()['GeneratorStatus']);
        this.etablissment = this.siteInfosService.getEtabData();
        this.goodtoknow = this.siteInfosService.getGoodToKnow();
        this.proggressBare = this.calculCheckInCheckOut();
    }

    calculCheckInCheckOut() {
        let checkIn = this.etablissment['pCheckIn'];
        let checkOut = this.etablissment['pCheckOut'];
        let explodeCheckIn = checkIn.split('-');
        let explodeCheckOut = checkOut.split('-');
        if ( explodeCheckIn.length > 1) {
            this.checkInCheckOutBare.startCheckIn = explodeCheckIn[0].replace(':','');
            this.checkInCheckOutBare.endCheckIn = explodeCheckIn[1].replace(':','');
            if (this.checkInCheckOutBare.endCheckIn == 0) {
                this.checkInCheckOutBare.endCheckIn = 2400;
            }
        } else {
            this.checkInCheckOutBare.startCheckIn = explodeCheckIn[0].replace(':','');
            this.checkInCheckOutBare.endCheckIn = 2400;
        }
        if ( explodeCheckOut.length > 1) {
            this.checkInCheckOutBare.startCheckOut = explodeCheckOut[0].replace(':','');
            this.checkInCheckOutBare.endCheckOut = explodeCheckOut[1].replace(':','');
            if (this.checkInCheckOutBare.startCheckOut == 0) {
                this.checkInCheckOutBare.startCheckOut = 0;
            }
        } else {
            this.checkInCheckOutBare.startCheckOut = 0;
            this.checkInCheckOutBare.endCheckOut = explodeCheckOut[0].replace(':','');
        }
        let percentStartCheckIn = (this.checkInCheckOutBare.startCheckIn * 100 ) / 2400;
        let percentEndCheckIn = (this.checkInCheckOutBare.endCheckIn * 100) / 2400;
        let percentStartCheckOut = (this.checkInCheckOutBare.startCheckOut * 100) / 2400;
        let percentEndCheckOut = (this.checkInCheckOutBare.endCheckOut * 100) / 2400;
        return [ percentStartCheckIn.toFixed(2), (percentEndCheckIn - percentStartCheckIn).toFixed(2), percentStartCheckOut.toFixed(2), (percentEndCheckOut - percentStartCheckOut).toFixed(2) ];
    }

    /**
    * lang
    * @returns string lang
    */
     get lang(): string {
        return this.winRef.appConfigSite.defaultlangue
    }

}
